import React from 'react';

const Popup = ({ children, type }) => {
    // Determine the CSS class based on the popup type (e.g., "warn" for warning popups)
    const popupClass = type === "warn" ? "warn-popup" : "popup";
    
    return (
        <div className={popupClass}>
            {/* Render the children elements passed into the popup */}
            {children}
        </div>
    )
};

export default Popup;
